import { createTheme, ThemeProvider } from '@mui/material';

const theme = createTheme({
  typography: {
    fontFamily: 'TeleNeo, Roboto, sans-serif',
    h1: {
      fontSize: '96px',
      fontWeight: 655,
      lineHeight: 1,
    },
    h2: {
      fontSize: '56px',
      fontWeight: 655,
      lineHeight: 1,
    },
    h3: {
      fontSize: '48px',
      fontWeight: 655,
      lineHeight: 1,
    },
    h4: {
      fontSize: '32px',
      fontWeight: 655,
      lineHeight: 1,
    },
    h5: {
      fontSize: '24px',
      fontWeight: 655,
      lineHeight: 1,
    },
    h6: {
      fontSize: '20px',
      fontWeight: 655,
      lineHeight: 1.2,
    },
    subtitle1: {
      fontSize: '16px',
      fontWeight: 655,
      lineHeight: 1.25,
    },
    subtitle2: {
      fontSize: '14px',
      fontWeight: 655,
      lineHeight: 1.25,
    },
    body1: {
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: 1.25,
    },
    body2: {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: 1.25,
    },
    button: {
      fontSize: '16px',
      fontWeight: 655,
      lineHeight: 1.25,
      textTransform: 'none',
    },
    caption: {
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: 1.3,
    },
    overline: {
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: 1.25,
      textTransform: 'uppercase',
    },
  },
  palette: {
    primary: {
      main: '#e20074',
      dark: '#B5005D',
      light: '#e20074',
    },
    secondary: {
      main: '#000',
      dark: '#000',
      light: '#fff',
    },
  },
});

export const MuiThemeContext = ({ children }) => <ThemeProvider theme={theme}>{children}</ThemeProvider>;
